import React from "react";
import {
  formatToman,
  getRemainingWithdrawalText,
} from "../../utils/referralHelpers";

export default function WithdrawalCard({
  availableBalance,
  minimumWithdrawalAmount,
  progress,
  canWithdraw,
  onOpen,
}) {
  return (
    <section className="mt-5 rounded-[2rem] border border-white/10 bg-[#10182A]/90 p-5 shadow-xl">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-black text-white">
            برداشت درآمد
          </h2>

          <p className="mt-2 text-sm text-slate-400">
            {getRemainingWithdrawalText(
              availableBalance,
              minimumWithdrawalAmount
            )}
          </p>
        </div>

        <button
          type="button"
          disabled={!canWithdraw}
          onClick={onOpen}
          className={`px-5 py-3 rounded-2xl font-bold transition ${
            canWithdraw
              ? "bg-gradient-to-l from-green-500 to-emerald-500 text-white shadow-lg shadow-green-500/20"
              : "bg-white/5 text-slate-500 cursor-not-allowed"
          }`}
        >
          درخواست برداشت
        </button>
      </div>

      <div className="mt-5 h-3 rounded-full bg-slate-800 overflow-hidden">
        <div
          className="h-full bg-gradient-to-l from-green-500 to-blue-500 transition-all"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="mt-3 flex justify-between text-xs text-slate-400">
        <span>{formatToman(availableBalance)}</span>
        <span>{formatToman(minimumWithdrawalAmount)}</span>
      </div>
    </section>
  );
}